import React, { Component }  from 'react';
import '../../style.css';
import {fetchPost} from "../../static/util/fetch";
import {
    Button,
    Card,
    Dropdown,
    Form,
    Input, List,
    Menu,
    message,
    Modal,
    PageHeader, Select,
    Space,
    Table,
    Tag
} from "antd";
import {
    CaretDownOutlined,
    DeleteOutlined,
    EditOutlined, MailOutlined, PauseCircleOutlined, StopOutlined
} from "@ant-design/icons";
import CompanyPaceMain from "../CompanyPaceMain";
const { Column } = Table;
const Option = Select.Option;
class SuperManagerList extends Component {
    constructor(props) {
        super(props);
        this.state={
            admin:[],
            user:[],
            edit_visible:false,//编辑弹窗状态
            add_visible:false,//添加弹窗状态
            delete_visible:false,//删除弹窗状态
            deleteId: 0,//待删除id
            editId: 0,
            ifDown_visible:false,
            downId:0,
            areaChoose:'请选择地区',
            userId:'',
            username:'',
            phone:'',
            password:'',
            area:'',
            loading:false,
            frozen_visible:false,
            frozenId:'',
            transfer_visible:false,
            transferId:'',
            activateId:'',
            activate_visible:false,
            areaList:[],
            tabBar:1,
            tabBar1:1,
            company:[],
            companyName:'',
            companyId:0,
        }
        this.hideModal = this.hideModal.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.chooseArea = this.chooseArea.bind(this);
    }
    componentDidMount() {
        this.setState(()=>({
            loading:true
        }))
        fetchPost(global.constants.getAllAdmins,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            admin:res.data,
                            loading:false
                        }))
                    }else{
                        this.setState(()=>({
                            loading:false
                        }))
                        message.info(res.msg).then();
                    }
                }
            )
        fetchPost(global.constants.getAllUsers,{})
            .then(
                res=>{
                    if(res.code === 200) {
                        this.setState(() => ({
                            user: res.data,
                        }))
                    }
                }
            )
        fetchPost(global.constants.getAllUserAreaList,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            areaList:res.data
                        }))
                    }
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            edit_visible:false,
            delete_visible:false,
            ifDown_visible:false,
            frozen_visible:false,
            activate_visible:false,
        }))
    }
    hideModalTwo(){
        this.setState(()=>({
            transfer_visible:false,
        }))
    }
    handleEnter = (e)=>{
        const value = e.id;
        fetchPost(global.constants.adminGetCompanyList,{userId:value})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            company:res.data,
                        }))
                    }
                    else{
                        message.info('该用户未绑定公司').then();
                        this.setState(()=>({
                            company:[],
                        }))
                    }
                }
            )
    }
    seePace(e){
        const value = e
        fetchPost(global.constants.getCompany,{id:value})
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            companyName: res.data.companyName,
                            companyId:value,
                            tabBar1:2
                        }))
                    }})
    }
    handleEditList(e){
        const value = e.id;
        let params = {
            userId:e.id,
            username:e.username,
            phone:e.phone,
            password:e.password,
            area:e.area,
        }
        this.setState(()=>({
            editId:value,
        }))
        fetchPost(global.constants.adminUpdateUser,params)
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            userId:res.data.id,
                            username:res.data.username,
                            phone:res.data.phone,
                            password:res.data.password,
                            area:res.data.area,
                            edit_visible:true,
                        }))
                    }
                    // if(res.code === -1){
                    //     console.log("获取待修改人员信息失败")
                    // }
                }
            )
    }
    updateUser(){
        const regPassword =/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,}$/;
        const newResPassword = regPassword.test(this.state.password);
        const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
        const newResPhone = regPhone.test(this.state.phone)
        if(newResPhone === false ){
            message.error("请检查该手机号是否真实！").then()
        }else {
            if (this.state.password !== null && newResPassword === false) {
                message.error("请注意密码格式！").then()
            } else {
                let params = {
                    userId: this.state.editId,
                    username: this.state.username,
                    phone: this.state.phone,
                    password: this.state.password,
                    area: this.state.area,
                }
                fetchPost(global.constants.adminUpdateUser, params)
                    .then(
                        res => {
                            console.log(res)
                            if (res.code === 200) {
                                message.success(res.msg).then()
                                this.setState(() => ({
                                    edit_visible: false
                                }))
                                if (this.state.areaChoose == '请选择地区') {
                                    fetchPost(global.constants.getAllAdmins, {})
                                        .then(
                                            res => {
                                                if (res.code === 200) {
                                                    this.setState(() => ({
                                                        admin: res.data,
                                                    }))
                                                } else {
                                                    message.info(res.msg).then()
                                                    this.setState(() => ({
                                                        admin: []
                                                    }))
                                                }
                                            }
                                        )//更新后重新获取
                                } else {
                                    fetchPost(global.constants.getAreaAdmins, {userArea: this.state.areaChoose})
                                        .then(
                                            res => {
                                                if (res.code === 200) {
                                                    this.setState(() => ({
                                                        admin: res.data
                                                    }))
                                                } else {
                                                    message.info(res.msg).then();
                                                    this.setState(() => ({
                                                        admin: []
                                                    }))
                                                }
                                            }
                                        )
                                }
                            }
                            if (res.code === -1) {
                                message.error(res.msg).then()
                            }
                            // if(res.code === null){
                            //     console.log("返回值为空，修改失败")
                            // }
                        }
                    )
            }
        }
    }
    handleDeleteList(e){
        const value = e.id;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value,
        }))
    }
    deleteUser(){
        fetchPost(global.constants.adminDeleteUser,{userId:this.state.deleteId})
            .then(
                res => {
                    if(res.code === 200){
                        message.success('删除用户信息成功！').then();
                        this.setState(()=>({
                            delete_visible:false
                        }))
                        if(this.state.areaChoose == '请选择地区'){
                            fetchPost(global.constants.getAllAdmins,{})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                admin:res.data,
                                            }))
                                        }
                                        else{
                                            message.info(res.msg).then()
                                            this.setState(()=>({
                                                admin:[]
                                            }))
                                        }
                                    }
                                )//更新后重新获取
                        }else{
                            fetchPost(global.constants.getAreaAdmins,{userArea:this.state.areaChoose})
                                .then(
                                    res=>{
                                        if(res.code === 200){
                                            this.setState(()=>({
                                                admin:res.data
                                            }))
                                        }else{
                                            message.info(res.msg).then();
                                            this.setState(()=>({
                                                admin:[]
                                            }))
                                        }
                                    }
                                )
                        }

                    }
                    if(res.code === -1){
                        message.error(res.msg).then()
                    }
                    // if(res.code === null){
                    //     console.log("删除失败")
                    // }
                }
            )
    }
    chooseArea(e){
        const value = e
        this.setState(()=>({
            areaChoose:value,
            loading:true
        }))
        if(value === '全部地区'){
            fetchPost(global.constants.getAllAdmins,{})
                .then(
                    res=>{
                        if(res.code === 200){
                            this.setState(()=>({
                                admin:res.data,
                                loading:false
                            }))
                        }else{
                            this.setState(()=>({
                                admin: [],
                                loading:false
                            }))
                            message.info(res.msg).then();
                        }
                    }
                )
        }else {
            fetchPost(global.constants.getAreaAdmins, {userArea: value})
                .then(
                    res => {
                        if (res.code === 200) {
                            this.setState(() => ({
                                admin: res.data,
                                loading:false
                            }))
                        } else {
                            message.info(res.msg).then();
                            this.setState(() => ({
                                admin: [],
                                loading:false
                            }))
                        }
                    }
                )
        }
    }
    handleDown(e){
        this.setState(()=>({
            ifDown_visible:true,
            downId:e.id,
        }))
    }
    Down(){
        fetchPost(global.constants.adminRightReduction,{userId:this.state.downId})
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("降为普通用户成功").then()
                        this.setState(()=>({
                            ifDown_visible:false,
                        }))
                        fetchPost(global.constants.getAllUsers,{})
                            .then(
                                res=>{
                                    if(res.code === 200) {
                                        this.setState(() => ({
                                            user: res.data,
                                        }))
                                    }
                                }
                            )
                        if(this.state.areaChoose == '请选择地区'){
                            fetchPost(global.constants.getAllAdmins,{})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                admin:res.data,
                                            }))
                                        }
                                        else{
                                            message.info(res.msg).then()
                                            this.setState(()=>({
                                                admin:[]
                                            }))
                                        }
                                    }
                                )//更新后重新获取
                        }else{
                            fetchPost(global.constants.getAreaAdmins,{userArea:this.state.areaChoose})
                                .then(
                                    res=>{
                                        if(res.code === 200){
                                            this.setState(()=>({
                                                admin:res.data
                                            }))
                                        }else{
                                            message.info(res.msg).then();
                                            this.setState(()=>({
                                                admin:[]
                                            }))
                                        }
                                    }
                                )
                        }
                    }else{
                        message.info(res.msg).then();
                        this.setState(()=>({
                            admin:[]
                        }))
                    }
                }
            )
    }
    getAllManagers(){
        fetchPost(global.constants.getAllAdmins,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            admin:res.data,
                            areaChoose:'请选择地区'
                        }))
                    }else{
                        message.info(res.msg).then();
                    }
                }
            )
    }
    handleFrozenList(e){
        this.setState(()=>({
            frozenId:e.id,
            frozen_visible:true,
            tabBar:1
        }))
    }
    frozenAccount(){
        fetchPost(global.constants.frozenAccount,{id:this.state.frozenId})
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("该账户已冻结！").then()
                        this.setState(()=>({
                            frozen_visible:false,
                            transfer_visible:false,
                            tabBar:1,
                        }))
                        if(this.state.areaChoose == '请选择地区'){
                            fetchPost(global.constants.getAllAdmins,{})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                admin:res.data,
                                            }))
                                        }
                                        else{
                                            message.info(res.msg).then()
                                            this.setState(()=>({
                                                admin:[]
                                            }))
                                        }
                                    }
                                )//更新后重新获取
                        }else{
                            fetchPost(global.constants.getAreaAdmins,{userArea:this.state.areaChoose})
                                .then(
                                    res=>{
                                        if(res.code === 200){
                                            this.setState(()=>({
                                                admin:res.data
                                            }))
                                        }else{
                                            message.info(res.msg).then();
                                            this.setState(()=>({
                                                admin:[]
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                })
    }
    frozenAccountTransfer(){
        this.setState(()=>({
            tabBar:2
        }))
    }
    handleTransfer(e){
        this.setState(()=>({
            transferId:e.id,
            transfer_visible:true,
        }))
    }
    transfer(){
        let params = {
            transferBefore:this.state.frozenId,
            transferBack:this.state.transferId,
        }
        fetchPost(global.constants.transferAccount,params)
            .then(
                res=>{
                    if(res.code === 200) {
                        fetchPost(global.constants.frozenAccount,{id:this.state.frozenId})
                            .then(
                                res=>{
                                    if(res.code === 200){
                                        message.success("该账户已冻结，且数据转移成功！").then()
                                        this.setState(()=>({
                                            frozen_visible:false,
                                            transfer_visible:false,
                                            tabBar:1,
                                        }))
                                        if(this.state.areaChoose == '请选择地区'){
                                            fetchPost(global.constants.getAllAdmins,{})
                                                .then(
                                                    res => {
                                                        if(res.code === 200) {
                                                            this.setState(()=>({
                                                                admin:res.data,
                                                            }))
                                                        }
                                                        else{
                                                            message.info(res.msg).then()
                                                            this.setState(()=>({
                                                                admin:[]
                                                            }))
                                                        }
                                                    }
                                                )//更新后重新获取
                                        }else{
                                            fetchPost(global.constants.getAreaAdmins,{userArea:this.state.areaChoose})
                                                .then(
                                                    res=>{
                                                        if(res.code === 200){
                                                            this.setState(()=>({
                                                                admin:res.data
                                                            }))
                                                        }else{
                                                            message.info(res.msg).then();
                                                            this.setState(()=>({
                                                                admin:[]
                                                            }))
                                                        }
                                                    }
                                                )
                                        }
                                    }
                                })
                    }else{
                        message.error("转移失败，该管理员的账户无数据，可直接冻结！").then()
                        this.setState(() => ({
                            transfer_visible:false
                        }))
                    }
                }
            )
    }
    handleActivateList(e){
        this.setState(()=>({
            activateId:e.id,
            activate_visible:true
        }))
    }
    activateAccount(){
        fetchPost(global.constants.activateAccount,{id:this.state.activateId})
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("解冻成功").then()
                        this.setState(()=>({
                            activate_visible:false
                        }))
                        if(this.state.areaChoose == '请选择地区'){
                            fetchPost(global.constants.getAllAdmins,{})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                admin:res.data,
                                            }))
                                        }
                                        else{
                                            message.info(res.msg).then()
                                            this.setState(()=>({
                                                admin:[]
                                            }))
                                        }
                                    }
                                )//更新后重新获取
                        }else{
                            fetchPost(global.constants.getAreaAdmins,{userArea:this.state.areaChoose})
                                .then(
                                    res=>{
                                        if(res.code === 200){
                                            this.setState(()=>({
                                                admin:res.data
                                            }))
                                        }else{
                                            message.info(res.msg).then();
                                            this.setState(()=>({
                                                admin:[]
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                })
    }
    handleChangeTabBar = (tabBar) => {
        this.setState({
            tabBar1: tabBar
        })
    }
    render() {
        // const menu = (
        //     <Menu>
        //         <Menu.Item onClick={this.getAllManagers.bind(this)}>
        //             全部
        //         </Menu.Item>
        //         <Menu.Item onClick={this.chooseArea.bind(this,'青岛')}>
        //             青岛
        //         </Menu.Item>
        //         <Menu.Item onClick={this.chooseArea.bind(this,'江苏')}>
        //             江苏
        //         </Menu.Item>
        //         <Menu.Item onClick={this.chooseArea.bind(this,'山东其他地区')}>
        //             山东其他地区
        //         </Menu.Item>
        //     </Menu>
        // )
        return(
            <div className="content-frame">
                <div className="content-form">
                    <div className="content-page-header">
                        <PageHeader
                            ghost={false}
                            title="管理员列表"
                            subTitle={"默认显示所有管理员"}
                        >
                        </PageHeader>
                    </div>
                    <Menu
                        theme="light"
                        selectedKeys={[this.state.tabBar1]}
                        mode="horizontal">
                        <Menu.Item key='1' onClick={this.handleChangeTabBar.bind(this, 1)} icon={<MailOutlined />}>
                            管理员列表
                        </Menu.Item>
                        <Menu.Item key='2' onClick={this.handleChangeTabBar.bind(this, 2)} >
                            {this.state.companyName}
                        </Menu.Item>
                    </Menu>
                    {
                        this.state.tabBar1 === 1 && (
                            <Space direction="vertical" className="content-style">
                                <div>
                                    {/*<Dropdown overlay={menu} placement="bottomCenter" arrow trigger='click'>*/}
                                    {/*    <Button type="primary" style={{marginRight: 5}}>{this.state.areaChoose}</Button>*/}
                                    {/*</Dropdown>*/}
                                    <Select showSearch
                                            style={{ width: 300 }}
                                            placeholder="请选择地区"
                                            optionFilterProp="children"
                                            notFoundContent="无法找到"
                                            searchPlaceholder="输入关键词"
                                            onChange={this.chooseArea.bind(this)}
                                            value={this.state.areaChoose}
                                            defaultValue={this.state.areaChoose}
                                    >
                                        <Option key="全部地区" value="全部地区">
                                            全部地区
                                        </Option>
                                        {
                                            this.state.areaList.map(item => (
                                                <Option key={item} value={item}>
                                                    {item}
                                                </Option>
                                            ))}
                                    </Select>
                                </div>
                                <Card bordered={true} style={{border: 'solid  1px #7F9DB9'}}>
                                    <Table dataSource={this.state.admin} loading={this.state.loading}
                                           onHeaderRow={() => {
                                               return {className: "list-column-style"}
                                           }}
                                           size={"small"}
                                    >
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">序号</p>}
                                            width="80"
                                            render={
                                                (text, record, index) => (`${index + 1}`)}/>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">用户名</p>}
                                            dataIndex="username"
                                            key="username"/>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">账号</p>}
                                            dataIndex="phone"
                                            key="phone"/>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">地区</p>}
                                            dataIndex="area"
                                            key="area"/>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">身份</p>}
                                            key="action"
                                            render={(text, record) => (
                                                record.identity === 1 ?
                                                    <Tag color="green" className="Tag_style">管理员</Tag> :
                                                    <Tag color="blue" className="Tag_style">普通用户</Tag>
                                            )}
                                        />
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">是否冻结</p>}
                                            key="action"
                                            render={(text, record) => (
                                                record.status === 0 ? <Tag color="green" className="Tag_style">否</Tag> :
                                                    <Tag color="red" className="Tag_style">是</Tag>
                                            )}
                                        />
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">权限</p>}
                                            key="action"
                                            render={(text, record) => (
                                                <Space size="middle">
                                                    <Button
                                                        type="primary"
                                                        icon={<CaretDownOutlined/>}
                                                        onClick={this.handleDown.bind(this, record)}
                                                    >降为普通用户</Button>
                                                </Space>
                                            )}
                                        />
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">查看进度</p>}
                                            key="action"
                                            render={(text, record) => (
                                                <Space size="middle">
                                                    <Select showSearch
                                                            placeholder="请选择公司"
                                                            optionFilterProp="children"
                                                            notFoundContent="无法找到"
                                                            searchPlaceholder="输入关键词"
                                                            onClick={this.handleEnter.bind(this, record)}
                                                            onSelect={this.seePace.bind(this)}
                                                        // value={this.state.companyName}
                                                    >
                                                        {
                                                            this.state.company.map(item => (
                                                                <Option
                                                                    key={item.id}
                                                                    value={item.id}
                                                                >
                                                                    {item.companyName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Space>
                                            )}
                                        />
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">操作</p>}
                                            key="action"
                                            render={(text, record) => (
                                                <Space size="middle">
                                                    <Button
                                                        type="primary"
                                                        icon={<EditOutlined/>}
                                                        onClick={this.handleEditList.bind(this, record)}
                                                    >编辑</Button>
                                                    <Button
                                                        type="primary"
                                                        icon={<DeleteOutlined/>}
                                                        onClick={this.handleDeleteList.bind(this, record)}
                                                    >删除</Button>
                                                    {
                                                        record.status === 0 ?
                                                            <Button
                                                                type="primary"
                                                                icon={<StopOutlined/>}
                                                                onClick={this.handleFrozenList.bind(this, record)}
                                                            >冻结</Button> :
                                                            <Button
                                                                type="primary"
                                                                icon={<PauseCircleOutlined/>}
                                                                onClick={this.handleActivateList.bind(this, record)}
                                                            >解冻</Button>
                                                    }
                                                </Space>
                                            )}
                                        />
                                    </Table>
                                </Card>
                            </Space>
                        )
                    }
                    {
                        this.state.tabBar1 === 2 &&
                        <CompanyPaceMain companyId={this.state.companyId} companyName={this.state.companyName}/>
                    }
                    <Modal
                        visible={this.state.edit_visible}
                        title={'修改用户信息'}
                        onOk={this.updateUser}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.updateUser}>
                                提交
                            </Button>,
                        ]}
                    >
                        <Form>
                            <Form.Item label="用户名" name="userName" >
                                <Input
                                    defaultValue={this.state.username}
                                    onChange={(e) => this.usernameChange(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item label="账号" name="phone" >
                                <Input
                                    defaultValue={this.state.phone}
                                    onChange={(e) => this.phoneChange(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item label="密码" name="password" >
                                <Input
                                    placeholder={'不输入数据即不更改密码'}
                                    defaultValue={this.state.password}
                                    onChange={(e) => this.passwordChange(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item label="地区" name="area" >
                                <Select showSearch
                                        allowClear
                                        defaultValue={this.state.area}
                                        style={{ width: 300 }}
                                        placeholder="请选择地区"
                                        optionFilterProp="children"
                                        notFoundContent="无法找到"
                                        searchPlaceholder="输入关键词"
                                        onChange={this.areaChange.bind(this)}
                                >
                                    {this.state.areaList.map(item => (
                                        <Option key={item} value={item}>
                                            {item}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Modal
                        visible={this.state.delete_visible}
                        title={'温馨提示'}
                        onOk={this.deleteUser}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.deleteUser}>
                                确定
                            </Button>,
                        ]}
                    >
                        <div>确定删除该用户吗？</div>
                    </Modal>
                    <Modal
                        visible={this.state.ifDown_visible}
                        title={'温馨提示'}
                        onOk={this.Down.bind(this)}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.Down.bind(this)}>
                                确定
                            </Button>,
                        ]}
                    >
                        <div>确定将该管理员降为普通用户吗？</div>
                    </Modal>
                    <Modal
                        visible={this.state.frozen_visible}
                        title={'温馨提示'}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.frozenAccount.bind(this)}>
                                直接冻结
                            </Button>,
                            this.state.tabBar === 1 &&
                            <Button key="submit" type="primary"  onClick={this.frozenAccountTransfer.bind(this)}>
                                转移数据并冻结
                            </Button>,
                        ]}
                    >
                        {
                            this.state.tabBar === 1 &&
                            <div>确定将该管理员的账户冻结吗？</div>
                        }
                        {
                            this.state.tabBar === 2 &&
                            <div>
                                <List
                                    pagination={{
                                        pageSize: 5,
                                    }}
                                    header={<div style={{fontWeight:'bolder',fontSize:'15px'}}>将其数据转移至用户</div>}
                                    dataSource={this.state.user}
                                    style={{width:'100'}}
                                    renderItem={item => (
                                        <List.Item
                                            actions={[
                                                item.status === 0?
                                                    <a key="list-edit" onClick={this.handleTransfer.bind(this,item)}>转移</a>:
                                                    <Tag color="red" className="Tag_style">已冻结</Tag>
                                            ]}>
                                            {/*<Typography.Text mark> </Typography.Text> */}
                                            {item.username}{item.phone}
                                        </List.Item>
                                    )}
                                />
                                <List
                                    pagination={{
                                        pageSize: 5,
                                    }}
                                    header={<div style={{fontWeight:'bolder',fontSize:'15px'}}>将其数据转移至管理员</div>}
                                    dataSource={this.state.admin}
                                    style={{width:'100'}}
                                    renderItem={item => (
                                        <List.Item
                                            actions={[
                                                item.status === 0?
                                                    <a key="list-edit" onClick={this.handleTransfer.bind(this,item)}>转移</a>:
                                                    <Tag color="red" className="Tag_style">已冻结</Tag>
                                            ]}>
                                            {/*<Typography.Text mark> </Typography.Text> */}
                                            {item.username}{item.phone}
                                        </List.Item>
                                    )}
                                />
                            </div>
                        }
                    </Modal>
                    <Modal
                        visible={this.state.transfer_visible}
                        title={'温馨提示'}
                        onOk={this.transfer.bind(this)}
                        onCancel={this.hideModalTwo.bind(this)}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.transfer.bind(this)}>
                                确定
                            </Button>,
                        ]}
                    >
                        <div>确定将数据转移至该用户/管理员吗？</div>
                    </Modal>
                    <Modal
                        visible={this.state.activate_visible}
                        title={'温馨提示'}
                        onOk={this.activateAccount.bind(this)}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.activateAccount.bind(this)}>
                                确定
                            </Button>,
                        ]}
                    >
                        <div>确定将该管理员的账户解冻吗？</div>
                    </Modal>
                </div>
            </div>
        )
    }
    usernameChange(e){
        this.setState({
            username:e
        })
    }
    phoneChange(e){
        this.setState({
            phone:e
        })
    }
    passwordChange(e){
        this.setState({
            password:e
        })
    }
    areaChange(e){
        this.setState({
            area:e
        })
    }
}
export default SuperManagerList;